import { Grid, Typography } from "@mui/material";
import React from "react";
import styled from "@emotion/styled";
import theme from "theme";
import ShapeWaves from "../react-bits/ShapeWaves";
import PageSelector from "./PageSelector";
import HeroSection from "./HeroSection";

const TopContainer = styled.div`
	width: 100%;
	// height: 600px;
	position: relative;
	overflow: hidden;
	padding-bottom: 20px;
`;

const ShapeWavesLayer = styled.div`
	position: absolute;
	inset: 0;
	z-index: 0;
`;

const ContentLayer = styled(Grid)`
	position: relative;
	z-index: 1;
	padding: 20px 50px 0px 50px;
	height: 100%;
	align-items: flex-start;

	@media (max-width: 600px) {
		padding: 20px 20px 0px 20px;
	}
`;

const HeaderRow = styled(Grid)`
	width: 100%;
`;

const SelectorRow = styled(Grid)`
	width: 100%;
	margin-top: 16px;
`;

const BlueOuterContainer = styled(Grid)`
	border: 1px solid ${theme.palette.primary.main};
	background-color: ${theme.palette.primary.main}80;
	border-radius: 100px;
	padding: 5px;
	margin-bottom: 20px;
	@media (max-width: 600px) {
		margin-bottom: 10px;
	}
`;

const BlueIconsContainer = styled(Grid)`
	border: 1px solid ${theme.palette.primary.main};
	background-color: ${theme.palette.primary.main}80;
	border-radius: 100px;
	padding: 10px 15px;
	display: flex;
	gap: 10px;
	margin-bottom: 20px;
	box-shadow: 0 0 10px rgba(0, 0, 0, 1);
`;

const BlueInnerContainer = styled(Grid)`
	border: 1px solid ${theme.palette.primary.main};
	background-color: white;
	border-radius: 100px;
	padding: 5px 15px 5px 5px;
`;

const IconContainer = styled(Grid)`
	border: 1px solid ${theme.palette.primary.main};
	background-color: white;
	border-radius: 100px;
	height: 44px;
	width: 44px;
	cursor: pointer;
	transform: scale(1);
	transform-origin: center center;
	transition: transform 0.2s ease, box-shadow 0.2s ease;
	&:hover {
		transform: scale(1.2);
		box-shadow: 0 0 10px ${theme.palette.primary.main};
	}
`;

const StyledTypography = styled(Typography)`
	font-weight: bold;
	margin: 0;
`;

const IconButton = ({ iconPath, alt, href }) => {
	return (
		<a
			href={href}
			target='_blank'
			rel='noopener noreferrer'
			style={{ textDecoration: "none" }}
		>
			<IconContainer item container justifyContent='center' alignItems='center'>
				<img src={iconPath} alt={alt} height={30} width={30} />
			</IconContainer>
		</a>
	);
};

const LeftSide = () => {
	return (
		<Grid item>
		</Grid>
		// <BlueOuterContainer item>
		// 	<BlueInnerContainer
		// 		container
		// 		justifyContent='space-between'
		// 		alignItems='center'
		// 	>
		// 		<img
		// 			src='/pictures/profile-pic.png'
		// 			alt='Eric'
		// 			height={38}
		// 			width={38}
		// 			style={{
		// 				marginRight: 10,
		// 			}}
		// 		/>
		// 		<StyledTypography sx={{ fontSize: 20 }}>
		// 			Heyo! I&apos;m Eric. Welcome to my portfolio!
		// 		</StyledTypography>
		// 	</BlueInnerContainer>
		// </BlueOuterContainer>
	);
};

const RightSide = () => {
	return (
		<Grid item>
			<BlueIconsContainer container>
				<IconButton
					iconPath='/icons/bi-linkedin.png'
					alt='LinkedIn'
					href='https://www.linkedin.com/in/eric-russell-1398b2125/'
				/>
				<IconButton
					iconPath='/icons/bi-instagram.png'
					alt='Instagram'
					href='https://www.instagram.com/ericsremote/'
				/>
				<IconButton
					iconPath='/icons/bi-producthunt.png'
					alt='Product Hunt'
					href='https://www.producthunt.com/@erussell4'
				/>
				<IconButton
					iconPath='/icons/bi-email.png'
					alt='Email'
					href='mailto:russell.eric6@gmail.com'
				/>
			</BlueIconsContainer>
		</Grid>
	);
};

const TopSection = ({ page, onPageChange }) => {
	return (
		<TopContainer>
			<ShapeWavesLayer>
				<ShapeWaves
					text=''
					fontFamily='Geist, "Geist Sans", system-ui, sans-serif'
					fontWeight={500}
					textSize={0.6}
					shapes='mixed'
					cellSize={10}
					dotSize={0.75}
					color='#2B2B2B'
					hoverColor='#00E0FF'
					backgroundColor='#ffffff'
					speed={1}
					scale={1}
					contrast={1}
					brightness={0.4}
					flow={0}
					direction={0}
					fade={0.25}
					interactive
					splashRadius={40}
					splashStrength={0.4}
					glow={0.35}
					intro
					introDuration={1.6}
					paused={false}
					onError={(error) => {
						console.error("ShapeWaves failed to initialize:", error);
					}}
				/>
			</ShapeWavesLayer>
			<ContentLayer container direction='column' justifyContent='center'>
				<HeaderRow container justifyContent='space-between'>
					<LeftSide />
					<RightSide />
				</HeaderRow>
				{/* <Grid item xs> */}
					<HeroSection />
				{/* </Grid> */}
				<SelectorRow container justifyContent='center'>
					<PageSelector value={page} onChange={onPageChange} />
				</SelectorRow>
			</ContentLayer>
		</TopContainer>
	);
};

export default TopSection;
